import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconCheckedSolid48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V44C48 46.2091 46.2091 48 44 48H4C1.79086 48 0 46.2091 0 44V4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.3778 18.4498L20.0959 36.7735L8.60645 25.6123L11.3936 22.7432L20.1264 31.2265L36.6223 15.5502L39.3778 18.4498Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconCheckedSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4142 7L9.50003 17.9142L3.58582 12L5.00003 10.5858L9.50003 15.0858L19 5.58579L20.4142 7Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconCheckedSolid16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="checkmark">
            <path
                d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4142 5L7.00003 12.4142L2.58582 8L4.00003 6.58579L7.00003 9.58579L13 3.58579L14.4142 5Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}
